export default "__VITE_ASSET__DMgfYcXp__"